module.exports = __webpack_public_path__ + "static/b-a-3-before-b9e6b110cce24428f5d8d47381a5f008.jpg";